export default {
  tabs: {
    marjorShareHolders: 'CỔ ĐÔNG LỚN',
    boardOfDirectors: 'BAN LÃNH ĐẠO',
  },

  listTitleTableMajorShareHolders: {
    NAME: 'TÊN',
    SHARES: 'CỔ PHIẾU',
    PERCENTAGE: 'TỶ LỆ SỞ HỮU',
    PUBLIC_DATE: 'CẬP NHẬT',
  },

  listTitleTableBOD: {
    NAME: 'TÊN',
    POSITION: 'CHỨC DANH',
    SHARES: 'SỞ HỮU',
    PERCENTAGE: 'TỶ LỆ ',
    PUBLIC_DATE: 'CẬP NHẬT',
  },

  listTitleTooltipShareHolder: {
    COMPANY: 'DOANH NGHIỆP',
    SHARES: 'SỞ HỮU',
    PERCENTAGE: 'TỶ LỆ',
    PUBLIC_DATE: 'CẬP NHẬT',
  },

  listTitleTooltipBoD: {
    AN_DATE: 'NGÀY BẮT ĐẦU GD',
    TYPE: 'KIỂU',
    REGISTER: 'ĐĂNG KÝ',
    RESULT: 'KẾT QUẢ',
    SHARE_BEFORE: 'SỞ HỮU TRƯỚC GD',
    SHARE_AFTER: 'SỞ HỮU SAU GD',
    PERCENTAGE: 'TỶ LỆ SỞ HỮU',
  },

  titleTooltip: {
    fiveLastestTransaction: '5 Giao Dịch Gần Nhất',
    investmentPortfolio: 'Danh Mục Đâu Tư',
  },

  multiLineTitleTable: {
    BEFOR: '(TRƯỚC)',
    AFTER: '(SAU)',
  },
  noData: 'Không có dữ liệu',

  titleChart: {
    overview: 'Tổng quan',
    marjorOwnership: 'Cổ đông lớn',
  },

  tooltipBODType: {
    buy: 'Mua',
    sell: 'Bán',
  },
};
